export default __webpack_public_path__ + "static/media/PRS_Logo_high.d3def567.png";